import { Employee } from './employeeType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class EmployeeApi {
    
    static async create(employee: Employee) {
        
        try {

            const response = await fetch(`${API_BASE_URL}/employees`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(employee),
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();
            
            if (response.status === 201 ) 
            {
                return responseBody
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else{
                if (responseBody.error.includes('duplicate')) {
                    // This checks if the word "duplicate" appears in the error message
                    //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else{
                    throw new Error(`${responseBody.error}, status: ${response.status}`);
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create employee: ${error.message}`);
            } else {
                throw new Error('Failed to create employee: An unknown error occurred.');
            }
        }
    }
    
    static async getEmployeeByCode(employee_code: string) {
        //get all emmplyees by company code in the token at back-end API side
        try {
            const response = await fetch(`${API_BASE_URL}/employees/code/${employee_code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                //credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {
                return responseBody;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else
            {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
            
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get employee: ${error.message}`);
            } else {
                throw new Error('Failed to get employee: An unknown error occurred.');
            }
        }
    }
    
    

    static async get() {
        //get all emmplyees by company code in the token at back-end API side
        try {
            const response = await fetch(`${API_BASE_URL}/employees/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();
            if (response.status === 200) {
                const employees: Employee[] = responseBody.data.map((item: any) => {
                    return {
                        employee_id: item.attributes.employee_id,
                        first_name: item.attributes.first_name,
                        last_name: item.attributes.last_name,
                        employee_code: item.attributes.employee_code,
                        is_active: item.attributes.is_active,
                        company_code: item.attributes.company_code,
                        company_name: item.attributes.company_name,
                        employee_type: item.attributes.employee_type,
                        employee_title: item.attributes.employee_title,
                        phone: item.attributes.phone,
                        email: item.attributes.email,
                        start_date: item.attributes.start_date,
                        end_date: item.attributes.end_date,
                        created_by_account_id: item.attributes.created_by_account_id,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                  });
                    return employees;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404){ //for no companies is found with this account!!
                    return [];
            }
            else
            {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
            
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get employee: ${error.message}`);
            } else {
                throw new Error('Failed to get employee: An unknown error occurred.');
            }
        }
    }


    static async update(employee_code: string, employee: Employee) {
        try {
            const response = await fetch(`${API_BASE_URL}/employees/${employee_code}`, {
                method: 'PUT',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ employee: employee }),
            });

            const responseBody = await response.json();
            if (response.status === 200) {
                return {
                    status: response.status,
                    //data: data,
                };
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update employee: ${error.message}`);
            } else {
                throw new Error('Failed to update employee: An unknown error occurred.');
            }
        }
    }

    static async delete(employeeId: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/employees/${employeeId}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return {
                status: response.status,
                ok: response.ok,
            };
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete employee: ${error.message}`);
            } else {
                throw new Error('Failed to delete employee: An unknown error occurred.');
            }
        }
    }

}

export default EmployeeApi;